module.exports = __webpack_public_path__ + "static/media/rank-desc@2x.ba778472.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/rank-desc@2x.png
// module id = 901
// module chunks = 0